//Components
import Module from '../../../../components/layout/Module';
import DataGrid from '../../../../components/table/DataGrid';
import StatusChip from '../components/StatusChip/StatusChip';
import IconTooltipButton from '../../../../components/button/IconTooltipButton';
import FormatDate from '../../../../components/date/FormatDate';

//Other dependencies
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadMySurveys } from '../../../../store/actions/dataEntryMySurveysActions';
import { alertReset, toggleAlertModule } from '../../../../store/actions/alert.actions';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from './Tabs';
import { Chip, Typography } from '@mui/material';
import { SURVEY_TYPE_ABOUT_CLASSES, SURVEY_TYPE_ABOUT_USERS } from '../constants/typeSurvey';

const MySurveysList = () => {
  const currentModule = 'dataentrymysurveys';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const permissions = useSelector((state) => state?.session?.permissions?.dataentrymysurveys ?? {});
  const loading = useSelector((state) => state?.dataEntryMySurveys?.mySurveys?.loading ?? false);
  const totalRecords = useSelector((state) => state?.dataEntryMySurveys?.mySurveys?.totalRecords ?? 0);
  const list = useSelector((state) => state?.dataEntryMySurveys?.mySurveys?.list ?? []);
  const skip = useSelector((state) => state?.datatable?.mySurveysList?.skip || 0);
  const rowsPerPage = useSelector((state) => state?.datatable?.mySurveysList?.rowsPerPage || 100);
  const columnsTable = useSelector((state) => state?.datatable?.mySurveysList?.columnsTable || []);

  useEffect(() => {
    dispatch(alertReset());
    dispatch(toggleAlertModule());
    dispatch(loadMySurveys(skip * rowsPerPage, rowsPerPage, {}));
  }, [skip, rowsPerPage]);

  const setCurrentRow = async (row, action) => {
    if ('marking' === action) {
      navigate(`/dashboard/data-entry/my-surveys/${row.surveyResultId}/fill-a-survey`);
    }
  };

  const getStatusChip = (survey) => {
    let type = '';
    let content = '';

    if (survey?.isCompleted) {
      type = 'done';
      content = 'Completed';
    } else if (!survey?.isCompleted && survey?.hasExpired) {
      type = 'error';
      content = 'Closed';
    } else if (!survey?.isCompleted && !survey?.hasExpired) {
      type = 'active';
      content = 'Active';
    } else {
      type = 'disabled';
      content = 'Unknown';
    }
    return (
      <div className='flex items-center justify-center'>
        <StatusChip content={content} type={type} />
      </div>
    );
  };

  const validateDate = (date = null) => {
    if (date) {
      return new Date(date);
    } else {
      return '';
    }
  };

  return (
    <Module>
      <Module.Header
        moduleName={currentModule}
        title='My Surveys'
        titleLink={'/dashboard/data-entry/my-surveys'}
      />

      <Module.Body>
        <Module.BodyHeader>
          <Tabs />
        </Module.BodyHeader>
        <Module.BodyContainer classNameWrapper='overflow-auto'>
          <DataGrid
            id='table-mysurveys'
            rows={list.map((row, index) => ({
              ...row,
              index: index + 1,
              name: (
                <div>
                  <Typography>{row?.surveyName || '-'}</Typography>
                  {[SURVEY_TYPE_ABOUT_CLASSES, ...SURVEY_TYPE_ABOUT_USERS].includes(row?.surveyType) && (
                    <Chip
                      size='small'
                      variant='outlined'
                      label={
                        <>
                          <b>{row?.surveyType.split('-').join(' ')}</b>
                          <span className='pl-2'>{row?.surveyAbout || '-'}</span>
                        </>
                      }
                    />
                  )}
                </div>
              ),
              creator: row?.createdBy?.fullName || '',
              questions: row?.surveyQuestionsLength || 0,
              status: <>{getStatusChip(row)}</>,
              assignedDate: row?.createdBy?.date ? <FormatDate date={row?.createdBy?.date} /> : null,
              dateFilledOut: validateDate(row?.dateFilledOut) ? (
                <FormatDate date={validateDate(row?.dateFilledOut)} />
              ) : null,
              date: row?.dueDate ? <FormatDate date={row?.dueDate} /> : null,
              note: row?.surveyNotes || '',
              actions: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  {permissions['marking'] && (
                    <IconTooltipButton
                      id={`survey-fill-${row._id}`}
                      disabled={loading || (row?.hasExpired && !row?.isCompleted)}
                      title={
                        row?.isCompleted ? 'View answers' : row?.hasExpired ? 'Survey closed' : 'Fill out'
                      }
                      icon={`${
                        row?.isCompleted ? 'expand-alt' : row?.hasExpired ? 'fa-lock' : 'pencil-mechanical'
                      }`}
                      onClick={() => setCurrentRow(row, 'marking')}
                    />
                  )}
                </div>
              )
            }))}
            labelNoRows="You don't have any survey yet"
            loading={loading}
            nameModule='mySurveysList'
            headers={[...columnsTable]}
            totalRows={totalRecords}
            skip={skip}
            rowsPerPage={rowsPerPage}
            columns={[
              {
                label: '#',
                key: 'index',
                align: 'center',
                width: 10,
                show: true,
                hide: false
              },
              ...columnsTable,
              {
                label: 'Actions',
                key: 'actions',
                align: 'center',
                show: true,
                hide: false
              }
            ]}
            orderByField='name'
          />
        </Module.BodyContainer>
      </Module.Body>
    </Module>
  );
};
export default MySurveysList;
